import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["panel", "clearButton"];

  open(event) {
    event.preventDefault();
    this.updateClearButton();
    this.panelTarget.style.display = "block";
  }

  close(event) {
    event.preventDefault();
    this.panelTarget.style.display = "none";
  }

  clearForm(event) {
    event.preventDefault();
    this.panelTarget.querySelectorAll("input[type=text], select").forEach(el => {
      const $el = window.jQuery && window.jQuery(el);
      if ($el && $el.hasClass("hasDatepicker")) {
        $el.datepicker("setDate", null);
      } else {
        el.value = "";
        if ($el && $el.hasClass("select2")) $el.trigger("change");
      }
    });
    this.clearButtonTarget.style.visibility = "hidden";
  }

  updateClearButton() {
    const hasValues = Array.from(
      this.panelTarget.querySelectorAll("input[type=text], select")
    ).some(el => el.value !== "");
    this.clearButtonTarget.style.visibility = hasValues ? "visible" : "hidden";
  }

  handleKeydown(event) {
    if (this.panelTarget.style.display === "none") return;
    if ((event.metaKey || event.ctrlKey) && event.key === "Enter") {
      this.panelTarget.querySelector("form").requestSubmit();
    }
    if (event.key === "Escape") {
      this.panelTarget.style.display = "none";
    }
  }
}
